// @flow
import React, {useState} from 'react';
import Box from 'sail/Box';
import {Intro} from 'sail/Text';
import ContentTabs, {ContentTab} from 'sail/ContentTabs';
import {ButtonLink} from 'sail/Button';
import {TextArea} from 'sail/Input';
import {defineMessages, useIntl} from 'react-intl';
import {FormattedMessageOrString} from '../../../../data/localization/intlUtils';
import Shell from './Shell';

import type {MessageConfig} from '../../data/GuideTypes';

const messages = defineMessages({
  buildInstructionsAriaBasic: {
    id:
      'docsApp.integrationBuilder.buildInstructions.buildInstructionsAriaBasic',
    description: 'Label for build instructions',
    defaultMessage: 'Build instructions',
  },
  buildInstructionsAriaActive: {
    id:
      'docsApp.integrationBuilder.buildInstructions.buildInstructionsAriaActive',
    description: 'Label for build instructions',
    defaultMessage:
      'Build instructions for installing Stripe with {activeLabel}',
  },
});

type Props = {|
  instructions: Array<{|
    body: MessageConfig,
    label: string | MessageConfig,
    command?: string,
    link?: {|
      label: MessageConfig,
      href: string,
    |},
    textarea?: string,
    shell?: boolean,
    large?: boolean,
  |}>,
|};

export function BuildInstructions(props: Props) {
  const [tab, setTab] = useState(0);
  const intl = useIntl();

  const {instructions} = props;
  const activeTab = tab >= instructions.length ? 0 : tab;
  const active = instructions[activeTab];

  return (
    <Box
      flex={{direction: 'column'}}
      margin={{bottom: 8}}
      className="BuildInstructions"
    >
      {instructions.length > 1 ? (
        <ContentTabs
          aria-label={intl.formatMessage(messages.buildInstructionsAriaBasic)}
          size="medium"
        >
          {instructions.map((instruction, i) => (
            <ContentTab
              key={i}
              onClick={(e) => setTab(i)}
              active={activeTab === i}
            >
              <FormattedMessageOrString
                stringOrDefineMessage={instruction.label}
              />
            </ContentTab>
          ))}
        </ContentTabs>
      ) : null}

      <Box
        flex={{direction: 'column', justifyContent: 'center'}}
        padding={{top: 8}}
      >
        <Box margin={{vertical: 8}}>
          <Intro>
            {' '}
            <FormattedMessageOrString stringOrDefineMessage={active.body} />
            {active.link && (
              <ButtonLink
                color="blue"
                style={{
                  margin: 0,
                  display: 'inline-flex',
                }}
                size="large"
                label={
                  <FormattedMessageOrString
                    stringOrDefineMessage={active.link.label}
                  />
                }
                href={active.link.href}
                target="_blank"
              />
            )}
          </Intro>
        </Box>

        {active.command && (
          <Shell
            command={active.command}
            shell={active.shell}
            large={active.large}
          />
        )}
        {active.textarea && (
          <TextArea
            aria-label={intl.formatMessage(
              messages.buildInstructionsAriaActive,
              {
                activeLabel: active.label,
              },
            )}
            value={active.textarea}
          />
        )}
      </Box>
    </Box>
  );
}
